export const COMMIT_HASH = 'b15017bfa170f5191b11fcba33b8f52abbdcfd1d';
